// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import Link from "next/link";
import * as Router from "next/router";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as Uuid$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/Uuid.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as HomeStoreEn$PorterinFeature from "../../../../containers/home/domain/store/HomeStoreEn.mjs";
import * as DownloadAppModuleScss from "../styles/DownloadApp.module.scss";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as DownloadAnalyticsHelper$PorterinFeature from "../../../../containers/download-app/helpers/DownloadAnalyticsHelper.mjs";
import * as StickyVisibilityContext$PorterinFeature from "../../../../contexts/sticky-visibilty-context/StickyVisibilityContext.mjs";

var styles = DownloadAppModuleScss;

function DownloadAppCmp(Props) {
  var data = Props.data;
  var router = Router.useRouter();
  var match = StickyVisibilityContext$PorterinFeature.useStickyVisibilityContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$1 = React.useState(function () {
        return false;
      });
  var card = data.card;
  var app_action = data.app_action;
  var setIsClosed = match$1[1];
  var publishStickyEvent = function (category, action) {
    var uuid = Uuid$PorterinUtils.generatedUuid(undefined);
    PublishEventsHelper$PorterinFeature.publishEvents(category, action, uuid);
  };
  var downloadLink = function (param) {
    return DownloadAnalyticsHelper$PorterinFeature.getAppDownloadLinkStickyTop(UrlUtils$Catalyst.getURLParams(router.asPath), citySelectedContext.city_selected, false, router.pathname);
  };
  if (match$1[0]) {
    return null;
  } else {
    return React.createElement("div", {
                className: "" + styles.wrapper + " " + (
                  match.isStickyHidden ? styles.hidden : ""
                ) + ""
              }, React.createElement("div", {
                    className: styles.container
                  }, React.createElement("div", {
                        className: styles.logo
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: card.icon.path,
                            height: 40.0,
                            width: 40.0,
                            quality: 100.0,
                            alt: card.icon.alt_text
                          })), React.createElement("div", {
                        className: styles["title-subtitle"]
                      }, React.createElement("div", {
                            className: styles.title
                          }, card.title), React.createElement("div", {
                            className: styles["sub-title"]
                          }, card.desc)), React.createElement("button", {
                        className: styles["download-button"],
                        id: "download-button-link",
                        onClick: (function (param) {
                            publishStickyEvent(citySelectedContext.category, HomeStoreEn$PorterinFeature.ga_button_sticky_top_download_action);
                            var callback = function (param) {
                              JsBindings$PorterinUtils.redirect(downloadLink(undefined));
                            };
                            citySelectedContext.category.toLowerCase();
                            Curry._1(callback, undefined);
                          })
                      }, React.createElement(Link, {
                            href: app_action.link,
                            children: app_action.label,
                            className: styles["download-button-text"]
                          })), React.createElement("button", {
                        className: styles["hide-button"],
                        onClick: (function (param) {
                            Curry._1(setIsClosed, (function (param) {
                                    return true;
                                  }));
                            publishStickyEvent(citySelectedContext.category, HomeStoreEn$PorterinFeature.ga_button_sticky_top_close_action);
                          })
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: data.close_icon.path,
                            height: 12.0,
                            width: 12.0,
                            quality: 100.0,
                            alt: "hide"
                          }))));
  }
}

var make = DownloadAppCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
